import { URL_QUIZ } from './urlQuiz';

export const QUIZ_REGISTRY = {
  [URL_QUIZ.slug]: URL_QUIZ,
};
